import Incomes from './Incomes'
export default Incomes
